function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseForm from "segments/desktop/core-components/base-form/base-form";
import { getZendeskFormConfig, ZENDESK_COMPANY_SIZE_INPUT_NAME, ZENDESK_TOPIC_INPUT_NAME } from "client/services/zendesk-service/zendesk-inputs";
import DefaultProps from "./default-props";
import { createZendeskTicket } from "client/services/zendesk-service/zendesk-service";
import { ZENDESK_FORM_SUBMIT_CLICKED, ZENDESK_FORM_SUBMIT_SUCCESS, ZENDESK_FORM_SUBMIT_FAILED } from "constants/bigbrain-event-types";
import { HELP_CENTER_LINK } from "constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
const SUBMIT_ASSET_SRC = "/static/img/forms/cs_representative.png";
class ZendeskForm extends PureComponent {
    render() {
        const formConfig = getZendeskFormConfig();
        const submitScreenData = {
            subTitleHtmlKey: "forms.zendesk.thanksPage.subTitle",
            postSubmitAssetSrc: SUBMIT_ASSET_SRC,
            footerLinkHtml: this.getKnowledgeBaseLinkHTML()
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "hubspot-contact-form-wrapper",
            children: /*#__PURE__*/ _jsx(BaseForm, {
                formConfig: formConfig,
                submitFormAsyncCallback: this.sendFormToZendesk,
                renderPrivacyNotice: true,
                submitScreenData: submitScreenData
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "normalizeFormData", (formData)=>{
            const normalizedData = {};
            formData.forEach((fieldData)=>{
                normalizedData[fieldData.name] = fieldData.value;
            });
            return normalizedData;
        });
        var _this = this;
        _define_property(this, "sendFormToZendesk", function() {
            var _ref = _async_to_generator(function*(formData) {
                const normalizedFormData = _this.normalizeFormData(formData);
                const companySize = normalizedFormData[ZENDESK_COMPANY_SIZE_INPUT_NAME];
                const topic = normalizedFormData[ZENDESK_TOPIC_INPUT_NAME];
                BigBrain("track", ZENDESK_FORM_SUBMIT_CLICKED, {
                    kind: topic,
                    info1: companySize
                });
                const responseData = yield createZendeskTicket(normalizedFormData);
                const success = responseData === null || responseData === void 0 ? void 0 : responseData.success;
                let errorMessage = null;
                if (responseData === null || responseData === void 0 ? void 0 : responseData.success) {
                    BigBrain("track", ZENDESK_FORM_SUBMIT_SUCCESS, {
                        kind: topic,
                        info1: companySize
                    });
                } else {
                    errorMessage = responseData === null || responseData === void 0 ? void 0 : responseData.message;
                    BigBrain("track", ZENDESK_FORM_SUBMIT_FAILED, {
                        kind: errorMessage
                    });
                }
                return {
                    success,
                    errorMessage
                };
            });
            return function(formData) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(this, "getKnowledgeBaseLinkHTML", ()=>{
            const { translate } = this.props;
            return `<a href="${HELP_CENTER_LINK}" target="_blank">
      ${translate("forms.thanksPage.KnowledgeBase")}</a>`;
        });
    }
}
export default withGenericConfig(ZendeskForm);
ZendeskForm.defaultProps = DefaultProps;
